import { Button } from "antd";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useCreatePool } from "../../entities/api";
import generateUUIdv4 from "../../utilities/generateUUIdv4";
import AddAndEditPoolModal from "./AddAndEditPoolModal";

const AddNewPool = () => {
  const { formatMessage } = useIntl();
  const [openModal, setOpenModal] = useState(false);
  const { mutateAsync: createFn, isPending } = useCreatePool();

  const handleCloseModal = () => setOpenModal((prev) => !prev);

  const handleSendRequest = async (form) => {
    try {
      const data = await form.validateFields();
      await createFn({
        ...data,
        poolCode: generateUUIdv4(),
      });
      handleCloseModal();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <Button
        onClick={handleCloseModal}
        icon={<i className="fas fa-plus" style={{ marginRight: "5px" }} />}
        type={"primary"}
      >
        {formatMessage({
          id: "pools.add",
          defaultMessage: "Add new pool",
        })}
      </Button>
      <AddAndEditPoolModal
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        handleSendRequest={handleSendRequest}
        okButtonLoading={isPending}
      />
    </>
  );
};

export default AddNewPool;
